var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72 1.44C4.90851 1.44 3.44 2.90851 3.44 4.72C3.44 6.53149 4.90851 8 6.72 8C8.53149 8 10 6.53149 10 4.72C10 2.90851 8.53149 1.44 6.72 1.44ZM2 4.72C2 2.11322 4.11322 0 6.72 0C9.32678 0 11.44 2.11322 11.44 4.72C11.44 7.32678 9.32678 9.44 6.72 9.44C4.11322 9.44 2 7.32678 2 4.72Z",
    fill: "#323F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95203 12.4525C3.01747 12.4525 1.4492 14.0208 1.4492 15.9554C1.4492 16.1234 1.44679 16.2816 1.44448 16.4326C1.43736 16.8995 1.43129 17.297 1.50105 17.6986C1.5691 18.0904 1.30666 18.4631 0.914883 18.5312C0.523104 18.5992 0.15034 18.3368 0.0822908 17.945C-0.0130433 17.3961 -0.00328922 16.8148 0.00495273 16.3236C0.00713057 16.1938 0.00920284 16.0703 0.00920284 15.9554C0.00920284 13.2255 2.22218 11.0125 4.95203 11.0125H9.0641C9.46174 11.0125 9.7841 11.3349 9.7841 11.7325C9.7841 12.1302 9.46174 12.4525 9.0641 12.4525H4.95203Z",
    fill: "#323F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59456 12.44C10.5291 12.44 12.0974 14.0083 12.0974 15.9428C12.0974 16.1108 12.0998 16.2691 12.1021 16.42C12.1092 16.887 12.1153 17.2845 12.0455 17.6861C11.9775 18.0778 12.2399 18.4506 12.6317 18.5187C13.0235 18.5867 13.3962 18.3243 13.4643 17.9325C13.5596 17.3836 13.5499 16.8023 13.5416 16.3111C13.5395 16.1813 13.5374 16.0578 13.5374 15.9428C13.5374 13.213 11.3244 11 8.59456 11H4.48249C4.08485 11 3.76249 11.3224 3.76249 11.72C3.76249 12.1176 4.08485 12.44 4.48249 12.44H8.59456Z",
    fill: "#323F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.99a235ebb2bacc28af92b1bccbe147f4.svg";
export { ForwardRef as ReactComponent };